import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Templates</Typography>
    <p>Templates define the design, variables and platform settings used when passes are issued. The selected template becomes the current template and is preselected elsewhere in Studio.</p>

    <Typography variant='h5'>Selecting and opening a template</Typography>
    <ul>
      <li>Click a row or preview card to select it. The selected template remains highlighted when you return to this page.</li>
      <li>Double-click a table row or preview card to open the template editor.</li>
      <li>Use the Active/Archived control to switch the list. Archived templates cannot be edited or used to issue passes until they are unarchived.</li>
    </ul>

    <Typography variant='h5'>Views and table tools</Typography>
    <p>Use the grid/list control to switch between preview cards and the data table. The table supports server-side search, filters, sorting, column visibility, density and export. The counters summarise issued, current, expired, installed and affected/synchronisation states for live passes; test passes are shown separately.</p>

    <Typography variant='h5'>Template actions</Typography>
    <p>The template menu acts on the currently selected template. Some actions open a dialog rather than a new page:</p>
    <ul>
      <li><strong>New template:</strong> choose a starting template and provide a name.</li>
      <li><strong>Duplicate template:</strong> provide a new name in the dialog. On success, the duplicate becomes the current template and opens in the editor.</li>
      <li><strong>Archive / unarchive:</strong> confirms the status change. Archiving preserves the template and its history.</li>
      <li><strong>Download data template:</strong> downloads a file containing the variables expected when issuing passes in bulk.</li>
    </ul>

    <Typography variant='h5'>Next steps</Typography>
    <p>Create a template, refine it in the editor, issue test passes, then create live passes once the design has been checked on real Apple and Google devices.</p>
  </div>
)

export default HelpText
